<template>
  <div class="container">
    <div class="content">
      <h2>🌟 Paws and Applaud! You've Nailed Your RiskyPaws Onboarding! 🌟</h2>
      <p>
        By sharing your financial tales with us, you've taken a courageous step forward on your path to purr-sonal wealth. 
        But guess what? You don't have to walk this path alone. Think of RiskyPaws as your trusty feline companion, ever curious and always by your side, 
        navigating the winding alleys of finance with you.
      </p>

      <!-- Display Onboarding Information -->
      <h3>Your Onboarding Summary:</h3>
      <ul>
        <li>Cat Whisperer: {{ store.formData.cat_whisperer }}</li>
        <li>Country of Residence: {{ store.formData.country_of_residence }}</li>
        <li>Relationship Status: {{ store.formData.marital_status }}</li>
        <li>Kids: {{ store.formData.dependents }}</li>
        <li>Pets: {{ store.formData.own_pets }}</li>
        <li>Onboarding Goals: {{ formatArray(store.formData.onboarding_goals) }}</li>
        <li>Cashflow Goals: {{ store.formData.cashflow_goals }}</li>
        <li>Housing Status: {{ store.formData.housing_status }}</li>
        <li>Car: {{ store.formData.car }}</li>
        <li>Credit: {{ store.formData.credit }}</li>
        <li>Investment: {{ formatArray(store.formData.investment) }}</li>
        <li>Insurance: {{ formatArray(store.formData.insurance) }}</li>
        <li>Employment Status: {{ formatArray(store.formData.employment_status) }}</li>
      
      </ul>

      <button @click="submitForm" class="button">Confirm and Complete Onboarding</button>
      <p v-if="successMessage">{{ successMessage }}</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </div> <br><br><br>
</template>

<script>
import axios from 'axios';
import { onboardingStore } from '@/components/stores/onboardingStore';
import { Auth } from 'aws-amplify';
import { ref } from 'vue';

export default {
  setup() {
    const store = onboardingStore();
    const successMessage = ref('');
    const errorMessage = ref('');

    // Define the formatArray function
    const formatArray = (array) => Array.isArray(array) ? array.join(', ') : '';


    const submitForm = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;

        // Preparing the payload directly from the store's formData, ensuring arrays are converted to strings if necessary
        const payload = {
          user: cognitoSub,
          cat_whisperer: store.formData.cat_whisperer,
          onboarding_goals: Array.isArray(store.formData.onboarding_goals) ? store.formData.onboarding_goals.join(',') : store.formData.onboarding_goals,
          cashflow_goals: store.formData.cashflow_goals,
          car: store.formData.car,
          credit: store.formData.credit,
          investment: Array.isArray(store.formData.investment) ? store.formData.investment.join(',') : store.formData.investment,
          insurance: Array.isArray(store.formData.insurance) ? store.formData.insurance.join(',') : store.formData.insurance,
          marital_status: store.formData.marital_status,
          housing_status: store.formData.housing_status,
          employment_status: Array.isArray(store.formData.employment_status) ? store.formData.employment_status.join(',') : store.formData.employment_status,
          country_of_residence: store.formData.country_of_residence,
          dependents: store.formData.dependents,
          pets: store.formData.own_pets
        };

        const response = await axios.post('https://api.riskypaws.com/frontoffice/api/client-info/', payload, {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });

        // Success handling
        successMessage.value = 'Your information has been successfully submitted!';
        console.log('Submission successful:', response.data);
      } catch (error) {
        // Error handling
        errorMessage.value = 'An error occurred while submitting your form. Please try again.';
        console.error('Error submitting form data:', error.response?.data || error);
      }
    };

    return {
      store,
      submitForm,
      successMessage,
      errorMessage,
      formatArray,
    };
  }
};
</script>

  <style scoped>
  .container {
    background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
  }
  
  .content {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    color: black;
  }
  
  .section-title {
    font-size: 1.2em;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #4A148C;
  }
  .button {
    background-color: #4A148C; /* Dark purple */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  }
  .form-section {
    margin-bottom: 20px;
    background-color: #f8f8f8;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  .selected {
    background-color: #4A148C;
    color: white;
  }
  
  /* Custom styles for dropdown and input */
  select, input {
    cursor: pointer;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  </style>